import React from 'react';

import './_Skeleton.scss';

type Props = {
    children?: React.ReactNode;
    on: boolean;
    variant: 'headline' | 'bio' | 'link' | 'purchase';
};

export const Skeleton = ({ on, children, variant }: Props) => {
    const SkeletonItems = () => {
        switch (variant) {
            case 'headline':
                return (
                    <div data-testid={variant} className={`skeleton ${variant}`}>
                        <div className="item thick" />
                        <div className="item thick med" />
                    </div>
                );
            case 'bio':
                return (
                    <div data-testid={variant} className={`skeleton ${variant}`}>
                        <div className="item thin med" />
                        <div className="item thin med" />
                        <div className="item thin short" />
                    </div>
                );
            case 'link':
                return (
                    <div data-testid={variant} className={`skeleton ${variant}`}>
                        <div className={`skeleton ${variant}`}>
                            <div className="item icon" />
                            <div className="item-flex">
                                <div className="item" />
                                <div className="item thin med" />
                                <div className="item thin short" />
                            </div>
                        </div>
                        <div className={`skeleton ${variant}`}>
                            <div className="item icon" />
                            <div className="item-flex">
                                <div className="item" />
                                <div className="item thin med" />
                                <div className="item thin short" />
                            </div>
                        </div>
                    </div>
                );
            case 'purchase':
                return (
                    <div data-testid={variant} className={`skeleton ${variant}`}>
                        <div className="item" />
                        <div className=" justify-space-between">
                            <div className="item item-flex" />
                            <div className="item item-flex" />
                        </div>
                        <div className="item" />
                    </div>
                );
        }
    };
    return on ? <SkeletonItems /> : <>{children}</>;
};
